(function()
{
	//Import classes
	var BaseState = include('WGBH.BaseState'),
		IntroPanel = include('WGBH.IntroPanel');


	/**
	 * The logic for the title state
	 * @class WGBH.TitleState
	 * @extends springroll.easeljs.BaseState
	 */
	var IntroState = function(options)
	{
		BaseState.call(this, new IntroPanel(), options);
	};
	
	
	// Extend the base class
	var p = extend(IntroState, BaseState);
	
	var trackedend;

	/**
	 * When the transition is done playing and we're fully in - not all images are loaded though!
	 */
	p.enterDone = function()
	{
		this.panel.background.interactive=true;
		this.next=this.next.bind(this);
		this.panel.background.on(app.taptype,this.next);

		app.soundtrack.playVO("gameintro");
		
		this.talking=true;
		app.trackmoviestart("gameintro");
		
		app.on('update',this.update);
	};
	
	p.ready=function() {
		var mouthss=app.config.spritesheets.intromouth;
		this.mouth=UIPanel.makeMovieClipFromZoeSpritesheet(mouthss,"mouth");

		this.panel.addChild(this.mouth);
		this.mouth.scale={x:0.9,y:0.9};
		this.mouth.position={x:790,y:350};
		this.mouth.gotoAndStop(0);
		this.panel.mouth=this.mouth;
		
		this.update=this.update.bind(this);
		this.voplayer=app.voPlayer;
		this.syncarray=app.config.lipsync.gameintro;
		
		this.vopos=0;
		
		this.panel.buttons.on("background",this.clickbg);
	};
	
	p.clickbg=function(ev) {
		app.trackstrayclick(ev.x,ev.y);
	};
	
	p.update=function(t) {
		if(this.talking && this.syncarray) {
			// vo should be sending position/duration data 
			this.vopos=this.voplayer.getElapsed()/this.voplayer.currentDuration;
			this.setmouth(this.syncarray[parseInt(this.vopos * this.syncarray.length)]);
		}
		
		if(!this.voplayer.playing) {
			this.talking=false;
			if(!trackedend) {
				trackedend=true;
				app.trackmovieend("gameintro");
				this.nextState();
			}
		}
	};
	
	p.setmouth=function(frame) {
		if(frame===undefined) return;
		this.mouth.gotoAndStop(frame);
	};


	p.next=function(ev) {
		if(this.talking) {
			app.trackmovieskip("gameintro");
			trackedend=true;
			this.voplayer.stop();
			this.talking=false;
		}
		this.nextState();
	};
	
	/**
	 * When the state fully exits
	 * @method  exit
	 */
	p.exit = function()
	{
		app.off('update',this.update);
		this.panel.buttons.off("background",this.clickbg);
		this.panel.background.off(app.taptype,this.next);
	};

	//Assign to namespace
	namespace("WGBH").IntroState = IntroState;
}());
